export default [
  {
    path: '/audit-assigned',
    name: 'audit-assigned',
    component: () => import('@/views/audit-assigned/AuditAssigned.vue'),
    meta: {
      title: 'Audit ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Audit Assigned',
      pageTitle: 'Audit ',
      breadcrumb: [
        {
          text: 'Audit Pending & Completed',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/assign-date-and-eng/:id',
    name: 'assign-date-and-eng',
    component: () => import(
      '@/views/audit-assigned/control-audit-assigned/AssignDateAndEng.vue'
    ),
    meta: {
      title: 'Assign Date And Eng ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Assign Date And Eng',
      pageTitle: 'Assign Date And Eng',
      breadcrumb: [
        {
          text: 'Audit Pending & Completed',
          to: '/audit-assigned',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]
